<script>
    import { getContext } from "svelte";
    import { Display, key as dimensionsDisplayKey } from "../context/dimensionsDisplay.js";

    let { variation } = $props();

    const getDimensionsDisplay = getContext(dimensionsDisplayKey) ?? null;
    const topInfoAsDimensionDisplayMode = (getDimensionsDisplay && getDimensionsDisplay()?.displayMode) ?? Display.KEEP_EXISTING;
    const shouldShowTopInfo = $derived(
        variation.topInfo &&
            (topInfoAsDimensionDisplayMode === Display.CALCULATE || topInfoAsDimensionDisplayMode === Display.KEEP_EXISTING)
    );
</script>

{#if shouldShowTopInfo}
    <div data-testid="top-info" class="reco_cinema__top-info-dimensions oc-copy-75">
        <span class="reco_cinema__top-info-content">{variation.topInfo}</span>
    </div>
{/if}

<style lang="scss">
    .reco_cinema__top-info-dimensions {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        /*                           */
        -webkit-box-orient: vertical;
        line-clamp: 2;
        -webkit-line-clamp: 2;
        white-space: normal;
    }

    .reco_cinema__top-info-content {
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
    }
</style>
